import React from 'react';
import './footer.scss';
import { featuredPortfolio } from '../../data.js';
import {
  Mail,
  Phone,
  LocationCity,
  Facebook,
  GitHub,
  Instagram,
  LinkedIn,
} from '@material-ui/icons';
function Footer() {
  return (
    <div className="footer" id="contact">
      <div className="wrapper">
        <div className="left">
          <h1>{'<Mirza Adeel Baig/>'}</h1>
          <div className="social">
            <a
              href="https://www.facebook.com/profile.php?id=100008751722786"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook className="SocailIcon" />
            </a>
            <a
              href="https://github.com/adeelbaig625"
              target="_blank"
              rel="noreferrer"
            >
              <GitHub className="SocailIcon" />
            </a>
            <a
              href="https://www.linkedin.com/in/mirza-adeel-baig-373082196/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedIn className="SocailIcon" />
            </a>
          </div>
        </div>
        <div className="right">
          <div className="section">
            <h2>Contact</h2>
            <div className="contactItem">
              <Phone className="Icon" />
              <span>+92 313 111 3549</span>
            </div>
            <div className="contactItem">
              <Mail className="Icon" />
              <span>adeelBaig625@gmail.com</span>
            </div>
            <div className="contactItem">
              <LocationCity className="Icon" />
              <span>Karachi, Pakistan</span>
            </div>
          </div>

          <div className="section">
            <h2>Projects</h2>
            {featuredPortfolio.map(
              (d, index) =>
                index < 5 && (
                  <div className="contactItem">
                    <a href={d.link}>{d.title}</a>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
